'use strict';

angular.module('AcaApp').controller('HomeController', [
  '$scope',
  '$rootScope',
  '$mdDialog',
  '$location',
  'HomeService',
  'LayoutService',
  'EmployerService',
  '$timeout',
  '$window',
  'SendService',
  'MsgBetweenCtrlService',
  'ManagedUserInformationService',
  'SettingsService',
  '$q',
  function(
    $scope,
    $rootScope,
    $mdDialog,
    $location,
    HomeService,
    LayoutService,
    EmployerService,
    $timeout,
    $window,
    sendService,
    msgBetweenCtrlService,
    ManagedUserInformationService,
    SettingsService,
    $q){
    $scope.userName = '';
    LayoutService.addFloatLayer('#trigger-new-record', '#layer-new-record');
    var irserrorReport = {};
    $scope.markFixError = false;
    var init = function(){
      HomeService.getInformationHome().then(function(data){
        getHomeNumbers(data);
        selectTaxYear();
      },
      function(error){
        console.log('Error: ', error);
      });
    };
    $scope.showGettingStarted = function(ev){
      $mdDialog.show({
        clickOutsideToClose: true,
        controller: 'DialogController',
        templateUrl: '/app/views/common/dialog/getStarted.html',
        parent: angular.element(document.body),
        targetEvent: ev
      });
    };
    $scope.goImport = function(){
      $location.path('import');
    };
    $scope.goSendForms = function(){
      $location.path('send');
    };
    $scope.goToRecords = function(){
      $location.path('records');
    };
    $scope.goToFixRecords = function(){
      $location.path('records').search({section: 'fix'});
    };
    $scope.goToParticipantDataEntry = function(){
      $location.path('records').search({section: 'participant'});
    };
    $scope.goToEmployerDataEntry = function(){
      $location.path('records').search({section: 'employer'});
    };
    $scope.goToForm = function(event){
      $location.path('records').search({section: event.target.getAttribute('data-form')});
    };
    $scope.goToHistoryPrintStatusFromHome = function(){
      $location.path('/send').search({section: 'print-history-data'});
    };
    $scope.goToSendTransmittalPageFromHome = function(xmit){
      var section = (xmit === 'federal') ? 'send-transmittal-status' : 'send-state-transmittal-status';
      $location.path('/send').search({section: section});
    };
    $scope.checkMangedServicesAndNotSovosProfile = function(){
      return ManagedUserInformationService.isManagedServicesAndNotSovosProfile();
    };
    $scope.setCurrentTaxYear = function(taxYear){
      $q.all([SettingsService.changeTaxYear(taxYear), SettingsService.updateTaxYearInJwt(taxYear)]).then(function(values){
        $window.sessionStorage.taxYear = taxYear;
        $window.sessionStorage.token = values[1].result.value;
        setInformationHome(callAddFirstPayer);
        checkErrorRecords();
      },
      function(error){
      });
    };

    $scope.checkTaxYear = function(){
      return ($window.sessionStorage.taxYear > 2018);
    };
    
    var setInformationHome = function(callback){
      HomeService.getInformationHome().then(function(data){
        getHomeNumbers(data);
        callback();
      });
    };
    var getHomeNumbers = function(data){
      $scope.numfilesimported = data.result.numfilesimported;
      $scope.numformsprinted = data.result.numformsprinted;
      $scope.numformstransmitted = data.result.numformstransmitted;
      $scope.numincompletepayeerows = data.result.numincompletepayeerows;
      $scope.numpayerrows = data.result.numpayerrows;
      $scope.numtotalpayeerows = data.result.numtotalpayeerows;
      $scope.numtotalx5bformrows = data.result.numtotalx5bformrows;
      $scope.numincompletex5bformrows = data.result.numincompletex5bformrows;
      $scope.numtotalx5cformrows = data.result.numtotalx5cformrows;
      $scope.numincompletex5cformrows = data.result.numincompletex5cformrows;  
    };
    var callAddFirstPayer = function(){
      checkFixRecords();
      var userHaveToAddFirstPayer = ($scope.numpayerrows === 0 && !$rootScope.isReadOnly);
      if(userHaveToAddFirstPayer){
        addFirstPayer();
      }
      else{
        $mdDialog.hide();
      }
    };
    var addFirstPayer = function(){
      $scope.employerAction = 'noEmployer';
      $timeout(function(){
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/employer/modals/form-employer.html',
          parent: angular.element(document.body),
          controller: 'EmployerController',
          locals: {
            currentEmployer: undefined
          }
        });
      }, 500);
    };
    var checkErrorRecords = function(){
      sendService.getIrsErrorReportsCount().then(function(data){
        if(data.result.value > 0){
          irserrorReport = data.result;
          $mdDialog.show({
            scope: $scope.$new(),
            controller: 'IrsErrorReportController',
            controllerAs: 'irserrCont',
            templateUrl: 'app/views/irsErrorReport/modals/messageIrsErrorReport.html',
            preserveScope: true
          });
        }
      });
    };
    var checkFixRecords = function(){
      // jscs:disable maximumLineLength
      // jscs:disable disallowImplicitTypeConversion
      $scope.markFixError = !!($scope.numincompletepayeerows !== 0 || $scope.numincompletex5bformrows !== 0 || $scope.numincompletex5cformrows !== 0);
    };
    var selectTaxYear = function(){
      if($window.localStorage['FirstTimeTaxYears'] !== 'false'){
        $scope.taxYears = $window.localStorage['TaxYears'].split(',');
        $window.localStorage['FirstTimeTaxYears'] = false;
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/common/TaxYear.html',
          parent: angular.element(document.body),
          escapeToClose: false
        });
      }
      else{
        callAddFirstPayer();
        checkErrorRecords();
      }
    };
    init();
  }
]);
